import { LocalStorageProviderStore } from "./localStorageProviderStore";
import { MemoryProviderStore } from "./memoryProviderStore";
import type { ProviderStore } from "./types";

export * from "./types";
export { LocalStorageProviderStore, MemoryProviderStore };
export { ApiProviderStore } from "./apiProviderStore";

function hasLocalStorage(): boolean { try { const k = "__t"; window.localStorage.setItem(k, "1"); window.localStorage.removeItem(k); return true; } catch { return false; } }
export const providerStore: ProviderStore = typeof window !== "undefined" && hasLocalStorage() ? new LocalStorageProviderStore() : new MemoryProviderStore();
